// extracted by mini-css-extract-plugin
module.exports = {"glossaryMainContainer":"styles_glossaryMainContainer__2ttxV","glossaryTitle":"styles_glossaryTitle__2cpJK","contentWrap":"styles_contentWrap__2mFIO"};